export default {
  mobile_app_average_order_value: {
    label: 'AOV via App',
  },
  mobile_app_gmv: {
    label: 'App Sales',
  },
  mobile_app_gmv_percentage: {
    label: 'Revenue % via App',
  },
  mobile_app_downloads: {
    label: 'Downloads',
  },
  mobile_app_orders_count: {
    label: 'App orders',
  },
  name: {
    label: 'Restaurant',
  },
  mobile_app_released_at: {
    label: 'Launch date',
  },
  title: 'Restaurant Directory',
};
